<template>
      <div class="xc-page xc-page-sandwich">
        <div class="xc-page-main">
          <!-- 面包屑 -->
          <div class="xc-breadcrumb">
            <!-- <router-link :to="$config.adminPath + '/device'">终端管理</router-link>
            <router-link :to="$config.adminPath + '/device'">终端列表</router-link> -->
            <a @click="close" style="cursor: pointer;">终端管理</a>
            <a @click="close" style="cursor: pointer;">终端列表</a>
            <a>播放列表</a>
          </div>

          <!-- 铺满 -->
          <div
            class="xc-row xc-s-flex"
            style="overflow: hidden;"
          >
            <div class="xc-card">
              <div class="xc-card-content">
                <div class="xc-info">
                  <div class="xc-info-title">终端信息</div>
                  <div class="xc-info-content">
                    <div class="xc-form-inline">
                      <div class="xc-info-content">
                        <div class="xc-info-row">
                          <div class="xc-info-item">设备名称：{{deviceDetail.deviceName?deviceDetail.deviceName:'无'}}</div>
                          <div class="xc-info-item">设备IP：{{deviceDetail.lastReportIp?deviceDetail.lastReportIp:'无'}}</div>
                          <div class="xc-info-item">设备MAC：{{deviceDetail.deviceMac?deviceDetail.deviceMac:'无'}}</div>
                          <div class="xc-info-item">终端类型：{{deviceDetail.deviceType?deviceDetail.deviceType:'无'}}</div>
                          <div class="xc-info-item">在线状态：{{deviceDetail.deviceStatus?deviceDetail.deviceStatus:'无'}}</div>
                        </div>
                      </div>
                      <!-- <xc-form-item label="设备名称">
                        <input
                          type="text"
                          :value="deviceDetail.deviceName"
                          maxlength="255"
                          class="xc-input xc-input-readonly"
                          readonly
                        >
                      </xc-form-item>
                      <xc-form-item label="设备IP">
                        <input
                          type="text"
                          :value="deviceDetail.lastReportIp"
                          maxlength="255"
                          class="xc-input xc-input-readonly"
                          readonly
                        >
                      </xc-form-item>
                      <xc-form-item label="设备MAC">
                        <input
                          type="text"
                          :value="deviceDetail.deviceMac"
                          maxlength="255"
                          class="xc-input xc-input-readonly"
                          readonly
                        >
                      </xc-form-item>
                      <xc-form-item label="终端类型">
                        <input
                          type="text"
                          :value="deviceDetail.deviceType"
                          maxlength="255"
                          class="xc-input xc-input-readonly"
                          readonly
                        >
                      </xc-form-item> -->
                    </div>
                    <!-- <div class="xc-form-inline">
                      <xc-form-item label="在线状态">
                        <input
                          type="text"
                          :value="deviceDetail.deviceStatus"
                          maxlength="255"
                          class="xc-input xc-input-readonly"
                          readonly
                        >
                      </xc-form-item>
                    </div> -->
                  </div>
                </div>
                <div class="xc-info">
                  <div class="xc-info-title">播放列表</div>
                  <div class="xc-info-content">
                    <div class="xc-row-scroll">
                      <table class="xc-table">
                        <thead>
                          <tr>
                            <th>节目名称</th>
                            <th>节目素材</th>
                            <th>创建时间</th>
                            <th>下放时间</th>
                            <th>投放开始时间</th>
                            <th>投放结束时间</th>
                            <th>累计播放次数</th>
                            <th>累计播放时长</th>
                          </tr>
                        </thead>
                        <tbody>
                          <template v-if="list && list.length">
                            <tr
                              v-for="(item,key) in list"
                              :key="key"
                            >
                              <td>{{item.programName}}</td>
                              <td>
                                <div class="material-wrap">
                                  <div
                                  class="xc-device-material-program"
                                  :key="key"
                                  :data-index="key"
                                >
                                  <img
                                    :src="item.fileImageUrl"
                                    alt="素材图"
                                    :data-filename="item.fileName"
                                    :data-filetype="item.fileType"
                                    :data-url="item.url"
                                    @click="viewMaterial"
                                  >
                                  <div class="xc-device-material-name">{{item.fileName}}</div>
                                </div>
                                </div>
                              </td>
                              <td>{{item.addTime}}</td>
                              <td>{{item.pushTime}}</td>
                              <td>{{item.putinStartTime}}</td>
                              <td>{{item.putinEndTime}}</td>
                              <td>{{item.playCount}}次</td>
                              <td>{{item.playDuration}}</td>
                            </tr>
                          </template>
                          <template v-else>
                            <tr>
                              <td
                                colspan="14"
                                class="xc-s-tac"
                              >暂无数据</td>
                            </tr>
                          </template>
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- 固低栏 -->
        <div class="xc-page-footer">
          <div class="xc-btn-group">
            <!-- <router-link
              class="xc-btn xc-btn-default"
              :to="this.$config.adminPath + '/device'"
            >返回</router-link> -->
            <a class="xc-btn xc-btn-default" @click="close">返回</a>
          </div>
        </div>
      </div>
</template>

<script>
import myLayerImport from "@/libs/myLayer";
import mixin from "../xc-ui/mixins/list";
import deviceApi from "../api/device";

export default {
  mixins: [mixin],
  name: "devicePlayList",
  data() {
    return {
      // 列表key
      mix_listKey: "list",

      // 列表唯一字段
      mix_listId: "departmentId",

      playList: [],
      list: [],

      deviceDetail: {}
    };
  },

  async created() {
    // 加载JS
    await myLayerImport();
    // 获取全局值
    this.deviceDetail = JSON.parse(sessionStorage.getItem("deviceDetail"));
  },

  methods: {
    // 初始化数据
    initData(v) {
      // 默认搜索的数据
      const search = {
        ...this.mix_query,
        deviceCode: this.$route.params.deviceCode,
      };

      deviceApi.getCurrentSourcesByDeviceCode(search).then(v => {
        let ret = v;
        this.list = this.mix_format(ret.data);
        for(let item of ret.data)  {
          if (((item.playDuration)/1000/60) > 1 ) {
            let F = parseInt(item.playDuration/1000/60)
            item.playDuration = F + '分' + ((item.playDuration/1000/60 - F) * 60).toFixed(0) + "秒"
          } else {
            item.playDuration = ((item.playDuration)/1000).toFixed(0) + "秒"
          }
        }
      });
    },
    //预览素材
    viewMaterial(e) {
      let data = e.target.dataset;

      var program = {
        name: data.filename,
        type: data.filetype,
        url: data.url
      };

      myLayer.open({
        type: 2,
        title: false,
        shadeClose: true,
        closeBtn: 0, //不显示关闭按钮
        area: ["981px", "550px"],
        content:
          "/admin/material/preview?name=" +
          program.name +
          "&type=" +
          program.type +
          "&url=" +
          program.url,
        success: function(layero, index) {

        }
      });
    },

    close: function () {
        parent.myLayer.close(this.index);
    }
  },
  async mounted() {
    await myLayerImport();
    this.index = parent.myLayer.getFrameIndex(window.name);
  }
};
</script>

<style scoped lang="scss">
.material-wrap {
  display: flex;
  justify-content: center;
}

.xc-info-row .xc-info-item {
    display: inline-block;
    margin-right: 2rem;
    min-width: 0;
}

.xc-device-material-item,
.xc-device-material-program {
  width: 222px;
  height: 127px;
  border-radius: 4px;
  background: #eff2f8;
  margin-right: 16px;
  position: relative;
  display: flex;
  // align-items: center;
  // justify-content: center;
  overflow: hidden;
  box-sizing: border-box;
}

.xc-device-material-program {
  margin-right: 0;
}

.xc-device-material-name {
  position: absolute;
  left: 0;
  bottom: 0;
  width: 100%;
  height: 21px;
  background-color: rgba(0, 0, 0, 0.65);
  line-height: 20px;
  padding: 0 8px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  color: white;
  font-size: 12px;
  text-align: left;
}

.xc-device-material-program img {
  width: 100%;
  height: 100%;
  object-fit: contain;
}
</style>

